import React from 'react';

export default function CantinaHeader() {
  return (
    <div className="flex items-end justify-between gap-4">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amarillo-dorado">
          Driza Camp
        </p>

        <div className="mt-0.5 flex items-baseline gap-3">
          <h1 className="text-3xl font-bold leading-none text-blanco-puro">
            Cantina
          </h1>

          <span className="text-sm text-blanco-puro/75">
            Nueva venta
          </span>
        </div>
      </div>

      <div className="hidden rounded-lg border border-blanco-puro/20 bg-blanco-puro/10 px-3 py-2 text-[11px] text-blanco-puro/80 backdrop-blur md:block">
        <strong className="text-blanco-puro">Teclado:</strong>{' '}
        Enter agrega · ↑↓ selecciona · Esc limpia
      </div>
    </div>
  );
}
